import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import TeamLabel from '../shared/TeamLabel';
import { MatchRowWrapper, MatchRowLink } from './styles';
import ConfigManager from '../../common/configManager/configManager';
import Label from '../shared/Label';

const StandingRowDashed = ({
  teamRow, isHighlight, competitionId, isGazzanet, sportId,
}) => {
  const imagesURL = sportId === '2' ? ConfigManager.getRugbyTeams('min') : ConfigManager.getFootballTeams('min');

  /*const getGazzanetDomain = (url) => {
    let returnedDomain = 'gazzetta';
    if (url && url.hostname) {
      const site = url.hostname;
      const [, domain] = site.split('.');
      returnedDomain = domain;
    }
    return returnedDomain;
  };*/

  const generalRanking = teamRow.generalRanking ? teamRow.generalRanking : teamRow;

  return (
    <MatchRowWrapper
      isHighlight={isHighlight}
      className="generalBorder"
      //href={ConfigManager.prettyTeamUrl(1, competitionId, process.env.REACT_APP_SITE, generalRanking.teamName)}
    >
      {!isGazzanet ?
        <Row style={{
          width: '100%',
          marginRight: '0',
          marginLeft: '0',
          alignItems: 'center',
        }}
        >
          <Col
            md={10}
            sm={10}
            xs={10}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            {sportId === '2' ?
              <TeamLabel
                label={generalRanking.teamName}
                color="black"
                image={`${imagesURL}${generalRanking.teamId}.png`}
                marginLeft={0.5}
                font="narrowRegular"
                size={13}
                isStripCalendar
              />
            :
              <MatchRowLink
                href={ConfigManager.prettyTeamUrl(1, competitionId, process.env.REACT_APP_SITE, generalRanking.teamName)}
              >
                <TeamLabel
                  label={generalRanking.teamName}
                  color="black"
                  image={`${imagesURL}${generalRanking.teamId}.png`}
                  marginLeft={0.5}
                  font="narrowRegular"
                  size={13}
                  isStripCalendar
                />
              </MatchRowLink>
          }
          </Col>
          <Col
            md={2}
            sm={2}
            xs={2}
            style={{
              paddingRight: 0,
              paddingLeft: 0,
            }}
          >
            <Label
              label={generalRanking.points}
              weight="bold"
            />
          </Col>
        </Row>
        :
        <Row style={{
          width: '100%',
          marginRight: '5px',
          marginLeft: 0,
          paddingLeft: '5px',
          alignItems: 'center',
        }}
        >
          <Col
            md={6}
            sm={4.8}
            xs={4.8}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            <TeamLabel
              label={generalRanking.teamName}
              color="black"
              image={`${imagesURL}${generalRanking.teamId}.png`}
              marginLeft={0.5}
              font="narrowRegular"
              size={13}
              isStripCalendar
            />
          </Col>
          <Col
            md={1}
            sm={1.2}
            xs={1.2}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Label
              label={generalRanking.played}
              weight="bold"
            />
          </Col>
          <Col
            md={1}
            sm={1.2}
            xs={1.2}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Label
              label={generalRanking.won}
              weight="bold"
            />
          </Col>
          <Col
            md={1}
            sm={1.2}
            xs={1.2}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Label
              label={generalRanking.drawn}
              weight="bold"
            />
          </Col>
          <Col
            md={1}
            sm={1.2}
            xs={1.2}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Label
              label={generalRanking.lost}
              weight="bold"
            />
          </Col>
          <Col
            md={1}
            sm={1.2}
            xs={1.2}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Label
              label={generalRanking.goalsMade - generalRanking.goalsConceded}
              weight="bold"
            />
          </Col>
          <Col
            md={1}
            sm={1.2}
            xs={1.2}
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Label
              label={generalRanking.points}
              weight="bold"
            />
          </Col>
        </Row>
      }
    </MatchRowWrapper>
  );
};

StandingRowDashed.propTypes = {
  teamRow: PropTypes.any,
  //isMobile: PropTypes.bool,
  isHighlight: PropTypes.bool,
  competitionId: PropTypes.any,
  isGazzanet: PropTypes.bool,
  sportId: PropTypes.any,
};

export default StandingRowDashed;



// WEBPACK FOOTER //
// ./src/components/StandingRowDashed/index.js